var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuotation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1.852 7.852A3.77 3.77 0 0 1 5.63 4.074c2.074 0 3.777 1.704 3.74 3.778 0 4.704-3.444 6.963-5.481 7.889a1.07 1.07 0 0 1-1.482-1c0-.37.223-.741.556-.926 1.222-.741 1.926-1.519 2.333-2.222-1.926-.149-3.444-1.778-3.444-3.741m9 0a3.77 3.77 0 0 1 3.778-3.778c2.074 0 3.778 1.704 3.74 3.778 0 4.704-3.443 6.963-5.48 7.889a1.07 1.07 0 0 1-1.482-1c0-.37.222-.741.556-.926 1.222-.741 1.925-1.519 2.333-2.222-1.926-.149-3.445-1.778-3.445-3.741"
})));
SvgQuotation.displayName = "SvgQuotation";
export { SvgQuotation as ReactComponent };
export default SvgQuotation;